import { render } from "./OptionsExtra.vue?vue&type=template&id=4fd9bbb8"
import script from "./OptionsExtra.vue?vue&type=script&lang=js"
export * from "./OptionsExtra.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__